import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../../actions/actionCreators";
import MaterialModal from "../../MaterialModal";
import withModal from "../../withModal";
import { IFlowControlExecution } from "../../../../types/stores/flowControlExecution";
import { FormControl, InputLabel, Select, MenuItem, FormLabel, FormGroup } from "@material-ui/core";

const changeExecutionPriorityModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({
        continue: PropTypes.func.isRequired,
        cancel: PropTypes.func.isRequired,
        execution: PropTypes.any.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type ChangeExecutionPriorityModalProps = PropTypes.InferProps<typeof changeExecutionPriorityModalProps>;

const ChangeExecutionPriorityModal: React.FC<ChangeExecutionPriorityModalProps> = ({
    modalProps,
    isOpen,
}: ChangeExecutionPriorityModalProps) => {
    const dispatch = useDispatch();

    const execution = modalProps.execution as IFlowControlExecution;
    const [newPriority, setNewPriority] = useState(1);
    const [priorityValues] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9]);

    const hide = () => {
        dispatch(hideModal("FLOW_CONTROL_CHANGE_EXECUTION_PRIORITY"));
        modalProps.cancel();
    };

    const continueRequest = () => {
        modalProps.continue(execution.CorrelationId, newPriority);
        hide();
    };

    const calcultePriorityLevel = (priority: number) => (priority > 0 && priority <= 4 ? " (Low)" : " (High)");

    return (
        <MaterialModal
            title="Change Execution Priority"
            isOpen={isOpen}
            onClose={hide}
            id="change-execution-priority"
            maxWidth="sm"
            primaryButtonText="Continue"
            onPrimaryButtonRequest={() => continueRequest()}
        >
            <div className="row" style={{ marginBottom: "25px" }}>
                <div className="col-xs-12 col-sm-6">
                    <FormGroup style={{ marginBottom: "10px" }}>
                        <FormLabel>{execution?.JobInfo}</FormLabel>
                    </FormGroup>
                    <FormLabel>
                        Current priority: {execution?.Priority?.toString() + calcultePriorityLevel(execution?.Priority)}
                    </FormLabel>
                </div>
                <div className="col-xs-12 col-sm-6">
                    <FormControl fullWidth>
                        <InputLabel id="priority-select-label">New priority value:</InputLabel>
                        <Select
                            id="priority-select"
                            label="Priority value"
                            value={newPriority}
                            onChange={e => setNewPriority(e.target.value as number)}
                        >
                            {priorityValues.map(x => (
                                <MenuItem key={x} className="priority-select-option" value={x}>
                                    {x.toString() + calcultePriorityLevel(x)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
        </MaterialModal>
    );
};

export default withModal(ChangeExecutionPriorityModal, "FLOW_CONTROL_CHANGE_EXECUTION_PRIORITY");
